import useMediaQuery from 'hooks/useMediaQuery';
import HeaderNavigationLink from '../HeaderNavigationLink';
import CompanyDropdownComponent from './DropdownComponents/CompanyDropdownComponent';

const CompanyDropdown = ({ items, onClick }) => {
    const isTablet = useMediaQuery('max-width: 1023px');

    return (
        <>
            <div className="header-nav__item__dropdown-section col-4">
                <div className="link">{items.company_section}</div>
                {
                    items.company_items.map((item, index) => (
                        <HeaderNavigationLink
                            key={index}
                            data={item}
                            onClick={onClick}
                        />
                    ))}
            </div>
            <div className="header-nav__item__dropdown-section col-4">
                <div className="link">{items.resources_section}</div>
                {items.resources_items?.map((item, index) => (
                    <HeaderNavigationLink
                        key={index}
                        data={item}
                        onClick={onClick}
                        withUpArrow={true}
                    />
                ))}
            </div>
            {!isTablet && (
                <div className="header-nav__item__dropdown-section col-4">
                    <div className="link">{items.latest_news_section}</div>
                    <CompanyDropdownComponent onClick={onClick} />
                </div>
            )}
        </>
    );
};

export default CompanyDropdown;
